import React from 'react';
import SolutionDepositCheckWrapper from 'components/SolutionDepositCheckWrapper';

export default function SolutionDepositCheckContainer() {
  return (
    <SolutionDepositCheckWrapper />
  )
}
